import Product from '~/Api/Product/Product';

export default class Item {
	product: Product;

	packageSizeForSingleUnit: number | null;

	constructor(product: Product, packageSizeForSingleUnit: number | null) {
		this.product = product;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
	}
}
